import MoviesTopBar from './MoviesTopBar'
export default MoviesTopBar;